const CCLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="10"
    clipRule="evenodd"
    viewBox="0 0 330 330"
  >
    <defs>
      <clipPath id="TextBounds">
        <path d="M80.699 -92.509H394.682V313.313H80.699z"></path>
      </clipPath>
      <clipPath id="TextBounds_2">
        <path d="M-52.978 -12.147H204.82599999999996V381.2H-52.978z"></path>
      </clipPath>
    </defs>
    <clipPath id="ArtboardFrame">
      <path d="M0 0H330V330H0z"></path>
    </clipPath>
    <g clipPath="url(#ArtboardFrame)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-11.755-12.932h537.562V522.31H-11.755V-12.932z"
      ></path>
    </g>
    <g fillRule="evenodd">
      <path
        d="M317.355 290.311a261.054 261.054 0 01-40.235 10.449c-13.671 2.409-27.148 3.614-40.429 3.614-13.151 0-25.456-1.368-36.914-4.102-11.459-2.734-21.875-6.706-31.25-11.914-21.485-12.24-38.379-29.33-50.684-51.27-12.305-21.94-18.457-45.931-18.457-71.972 0-41.667 12.728-75.228 38.184-100.684 25.455-25.456 59.017-38.184 100.683-38.184 11.979 0 24.577 1.14 37.793 3.418 13.216 2.28 26.986 5.697 41.309 10.254v61.524h-22.266l-6.054-36.328-5.274-7.227c-7.682-3.516-15.169-6.12-22.461-7.812a98.132 98.132 0 00-22.265-2.54c-30.209 0-54.167 10.287-71.875 30.86-17.709 20.573-26.563 48.568-26.563 83.984 0 37.631 9.245 67.155 27.734 88.575 18.49 21.419 44.076 32.128 76.758 32.128a119.5 119.5 0 0017.285-1.269c5.795-.846 11.621-2.181 17.481-4.004l6.25-6.25 9.765-44.531h21.485v63.281z"
        clipPath="url(#TextBounds)"
      ></path>
      <path
        d="M14.753 73.545a208.808 208.808 0 0132.231-8.189c10.947-1.869 21.734-2.775 32.359-2.72 10.52.056 20.358 1.202 29.513 3.438 9.155 2.236 17.471 5.457 24.949 9.663 17.136 9.883 30.579 23.626 40.33 41.23 9.75 17.604 14.571 36.822 14.461 57.655-.177 33.333-10.501 60.128-30.973 80.385-20.472 20.256-47.374 30.296-80.707 30.12-9.584-.051-19.657-1.015-30.22-2.894-10.563-1.879-21.564-4.672-33.003-8.378l.26-49.218 17.813.094 4.69 29.088 4.188 5.803c6.13 2.845 12.11 4.96 17.935 6.345a78.516 78.516 0 0017.802 2.126c24.166.127 43.376-8 57.63-24.383 14.253-16.384 21.455-38.742 21.605-67.075.159-30.103-7.112-53.762-21.813-70.975-14.701-17.214-35.124-25.89-61.27-26.028a95.576 95.576 0 00-13.832.943c-4.64.652-9.306 1.695-14.002 3.129l-5.026 4.973-8 35.583-17.188-.091.268-50.624z"
        clipPath="url(#TextBounds_2)"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        strokeWidth="2.804"
        d="M161.2 90.137c-2.526 1.535-5.43 6.746-8.078 13.029-4.632 10.992-8.479 25.265-8.145 28.885M149.172 212.557c-.834-7.785-.67 10.864 17.784 34.492"
      ></path>
    </g>
  </svg>
);

export default CCLogo;
